// `feature`: o grupo so aparece quando o recurso esta ativo para o caso
// selecionado (ver layouts/Private.vue). `exactPath`: item ativo so na propria
// rota (sem contar as filhas).
const data = [
  {
    name: "Início",
    path: null,
    children: [
      { name: "Dashboard", icon: "mdi-home", route: "/home", path: "User" },
    ],
  },
  {
    name: "Fiscalização mensal",
    path: null,
    feature: "rma",
    children: [
      { name: "Documentos do mês", icon: "mdi-calendar-check-outline", route: "/fiscalizacao-mensal", path: "RmaDocuments", exactPath: true },
      { name: "Histórico", icon: "mdi-history", route: "/fiscalizacao-mensal/historico", path: "RmaHistory" },
      { name: "Questionários", icon: "mdi-clipboard-list-outline", route: "/fiscalizacao-mensal/questionarios", path: "RmaQuestionnaires" },
    ],
  },
  {
    // Solicitacoes do Juridico da AJ: mesmo fluxo da fiscalizacao, com tipos, prazo e periodicidade proprios.
    name: "Jurídico",
    path: null,
    feature: "legal",
    children: [
      { name: "Documentos", icon: "mdi-scale-balance", route: "/juridico", path: "RmaDocuments", exactPath: true },
      { name: "Histórico", icon: "mdi-history", route: "/juridico/historico", path: "RmaHistory" },
    ],
  },
  {
    name: "Verificação de créditos",
    path: "Manager",
    children: [
      // Oculto por enquanto; a rota /adesao-plano continua registrada.
      // { name: "Adesão ao Plano", icon: "mdi-file-sign", route: "/adesao-plano", path: "Client" },
      { name: "Credores", icon: "mdi-account-group-outline", route: "/credores", path: "Client" },
      { name: "Hab/Div", icon: "mdi-sync-alert", route: "/divergencias", path: "Event" },
      { name: "Documentos solicitados", icon: "mdi-file-document-edit-outline", route: "/documentos-solicitados", path: "Client" },
    ],
  },
];

export default [...data];
